<script setup lang="ts">
import { useWxShareStore } from './store';
import { initYoumeng } from './utils';

initYoumeng();

const wxShareStore = useWxShareStore();
wxShareStore.initWxShare({
  link: `${import.meta.env.VITE_PROJECT_BUILD_PATH}index.html`,
});
</script>

<template>
  <section class="mx-auto max-w-screen-sm h-screen app-container relative">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </section>
</template>
